<template>
  <div class="SegundaViaNascimento">
    <div class="SegundaViaNascimento_body">
      <div class="SegundaViaNascimento_header">
        Dados do registrador
      </div>
      <div class="SegundaViaNascimento_body_content p-2">
        <div class="row px-2">
          <div class="col-5">
            <div class="form-group">
              <label class="label">
                Nome do digitador
              </label>
              <select ref="nome_digitador"
                      v-model="nascimento.registro.digitador"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('digitador')}"
                      required
                      name="digitador"
                      @change="changed()">
                <option :value="null">
                  Selecione o digitador:
                </option>
                <option v-for="(digitador, index) of digitadores"
                        :key="index"
                        :value="digitador.nome">
                  {{ digitador.nome }}
                </option>
              </select>
              <small v-if="errors.has('digitador')"
                     class="invalid-feedback">
                {{ errors.first('digitador') }}
              </small>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="label">
                Escrevente
              </label>
              <select id="selectEscrevente"
                      v-model="nascimento.registro.escrevente"
                      v-validate="'required'"
                      class="form-control form-control-sm"
                      :class="{'is-invalid' : errors.has('escrevente')}"
                      required
                      name="escrevente"
                      @change="changeEscrevente()">
                <option :value="null">
                  Selecione o escrevente:
                </option>
                <option v-for="(escrevente, index) of escreventes"
                        :key="index"
                        :value="escrevente.nome">
                  {{ escrevente.nome }}
                </option>
              </select>
              <small v-if="errors.has('escrevente')"
                     class="invalid-feedback">
                {{ errors.first('escrevente') }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SegundaViaNascimento_body">
      <div class="SegundaViaNascimento_header">
        Dados do registro
      </div>
      <div class="SegundaViaNascimento_body_content p-2">
        <div v-if="!nascimento.registro.registro_id"
             class="col-12 d-inline-flex m-0 p-0">
          <div class="col-sm-12 px-2">
            <div class="form-group">
              <label for=""
                     class="label d-block">1ª via ou Legado</label>
              <span class="custom-control custom-radio custom-control-inline">
                <input
                  id="primeiraViaRegistro"
                  v-model="nascimento.registro.origem"
                  class="custom-control-input"
                  checked
                  name="primeiraViaRegistro"
                  type="radio"
                  value="novo"
                  @change="changeOrigin('novo')"
                  @keyup.enter="nascimento.registro.origem = 'novo'">
                <label
                  class="custom-control-label"
                  for="primeiraViaRegistro">1ª via</label>
              </span>

              <span class="custom-control custom-radio custom-control-inline">
                <input
                  id="legadoRegistro"
                  v-model="nascimento.registro.origem"
                  class="custom-control-input"
                  name="legadoRegistro"
                  value="legado"
                  type="radio"
                  @change="changeOrigin('legado')"
                  @keyup.enter="propNascimento.registro.origem = 'legado'">
                <label
                  class="custom-control-label"
                  for="legadoRegistro">Legado</label>
              </span>
            </div>
          </div>
        </div>
        <div v-if="nascimento.registro.origem === 'legado' || nascimento.registro.registro_id"
             class="row px-2 mb-4">
          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Livro</label>
            <input v-model="nascimento.registro.livro.num_livro"
                   v-validate="'required'"
                   type="number"
                   name="registro_livro"
                   :class="{'is-invalid' : errors.has('registro_livro')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>

          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Folha</label>
            <input v-model="nascimento.registro.folha"
                   v-validate="'required'"
                   type="number"
                   name="registro_folha"
                   :class="{'is-invalid' : errors.has('registro_folha')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>

          <div class="col-2">
            <label
              class="label"
              for="falecido_digitador_nome">Termo</label>
            <input v-model="nascimento.registro.termo"
                   v-validate="'required'"
                   type="number"
                   name="registro_termo"
                   :class="{'is-invalid' : errors.has('registro_termo')}"
                   class="form-control form-control-sm"
                   @change="verifyOrigin()">
          </div>
          <div class="col-3">
            <div class="form-group">
              <label
                class="label"
                for="data_registro">Data do Registro</label>
              <input
                id="data_registro"
                v-model="nascimento.registro.data_registro"
                v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                required
                class="form-control form-control-sm"
                name="data_registro"
                :class="{ 'is-invalid': errors.has('data_registro') }"
                placeholder="09/08/2019"
                type="date"
                @change="changed(), verifyOrigin()">
              <small v-if="errors.has('data_registro')"
                     class="invalid-feedback">{{ errors.first('data_registro') }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SegundaViaNascimento_body">
      <div class="SegundaViaNascimento_header">
        Nascido
      </div>
      <div class="SegundaViaNascimento_body_content p-2">
        <NascidoSV :prop-registro="nascimento.registro"
                   :prop-ordem-nascimento="nascimento.ordem_nascimento"
                   :prop-dnv="nascimento.numero_declaracao_nascido_vivo"
                   @removeGenitor="removeGenitor"
                   @removeGemeo="removeGemeo"
                   @deleteAvo="deleteAvo"
                   @updateOrdemNascimento="updateOrdemNascimento"
                   @changeDnv="changeDnv"
                   @changed="changed" />
      </div>
    </div>    
    <hr>
    <div class="row justify-content-end mr-2">
      <button v-if="nascimento.registro && nascimento.registro.existe_crc"
              id="btn-submit-registro"
              class="btn btn-sm btn-primary"
              type="button"
              @click="verificarDados()">
        Salvar
      </button>
      <button v-else
              id="btn-submit-registro"
              class="btn btn-sm btn-primary"
              type="button"
              @click="verifyInputs()">
        Salvar
      </button>
    </div>
    <MotivoAlteracao tipo="N"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="save($event)" />
  </div>
</template>

<script>
/* components */
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'
  import NascidoSV from '@/components/SofiaRei/Nascimento/SegundaVia/NascidoSV.vue'

  /* constants */
  import SEXOS from "@/constants/sexos"
  import brazilianStates from "@/constants/brazilianStates"
  
  /* services */
  import NascimentoService from "@/services/Registros/Nascimento"
  import UsuarioService from "@/services/Auth/UsuarioService"

  /* outros */
  import moment from "moment"

  /* libraries */
  import { mapGetters } from "vuex"

  export default {
    name: 'SegundaViaNascimento',
    components: {
      MotivoAlteracao,
      NascidoSV
    },
    props: {
      propNascimento: { type: Object, default: () => {}}
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        showNatDeclarada: false,
        show_naturalidade: true,
        constants: {
          brazilianCities: []
        },
        options: {
          SEXOS,
          estados: brazilianStates,
          cidades: []
        },
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
        nascimento: {
          registro: {
            pessoa: {}
          }
        },
        escreventes: [],
        digitadores: [],
        sequenciaRegistro: null,
        tarefaAlteracaoCarga: null,
        deleteds: { genitores: [], gemeos: [], filiacao: []}
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      }),
    },
    mounted () {
      this.nascimento = {
        ...this.propNascimento,
        registro: {
          ...this.propNascimento.registro,
          pessoa: { 
            ...this.propNascimento.registro.pessoa,
            genitores: this.propNascimento.registro.pessoa.genitores.map((genitor) => {
              return {
                ...genitor,
                pessoa: { 
                  ...genitor.pessoa,
                  endereco: {...genitor.pessoa.endereco}
                },
                filiacao: genitor.filiacao.map(avo => ({ ...avo }))
              }
            }),
            gemeos: this.propNascimento.registro.pessoa.gemeos.map(gemeo => ({ ...gemeo }))
          }
        }
      }
      this.loadUsers()
      this.getSequenciaRegistro()

      if (this.nascimento.data_casamento) {
        this.nascimento.data_casamento = moment(this.nascimento.data_casamento).format('YYYY-MM-DD')
      }

      this.tarefaAlteracaoCarga = this.nascimento.registro.tarefas.find((tarefa) => {
        return tarefa.acao === 'ALTERACAO' && tarefa.tipo === 'CARGA'
      })
    },
    methods: {
      changed (registro) {
        this.nascimento.registro = {
          ...this.nascimento.registro,
          ...registro
        }
      },
      verifyOrigin () {
        if (this.nascimento.registro.registro_id) {
          let { livro: { num_livro }, folha, termo } = this.nascimento.registro
          const sequenciaLocal = [num_livro, folha, termo].join('')

          if ((this.sequenciaRegistro != sequenciaLocal) || (this.nascimento.registro.data_registro != this.propNascimento.registro.data_registro)) {
            this.nascimento.registro.origem = 'legado'
          } else {
            this.nascimento.registro.origem = 'novo'
          }
        }
      },
      changeOrigin (origem) {
        if (origem === 'novo') {
          this.nascimento.registro = {
            ...this.nascimento.registro,
            termo: null,
            livro: {
              num_livro: null
            },
            folha: null,
            lado: null
          }
        }
      },
      async verificarDados () {
        const valid = await this.$validator.validateAll()
        
        const invalids = await this.scrollList()
        
        if (invalids || !valid) return

        this.$root.$emit('bv::show::modal', 'modalMotivoAlteracao')
      },
      async save ($event = null) {
        const data = $event
        try {
          loader({ text: 'Enviando dados...', active: true })
          this.$root.$emit('bv::hide::modal', 'modalMotivoAlteracao')

          if (data) {
            this.nascimento.registro.cod_motivo_alt = data.codigo
            this.nascimento.registro.data_averb_motivo_alt = data.dataAverb
          }

          let dnv = this.nascimento.registro.numero_declaracao_nascido_vivo
          this.nascimento.registro.numero_declaracao_nascido_vivo = dnv || null

          // this.nascimento.registro.pessoa.possui_gemeos_crc = this.possuiGemeosCRC

          if (!this.nascimento.registro.oficial) {
            this.nascimento.registro.oficial = this.cartorio.nome_oficial
          }

          if (this.nascimento.registro.pessoa.genitores.length) {
            this.nascimento.registro.pessoa.genitores.forEach(genitor => {
              genitor.filiacao = genitor.filiacao.filter(avo => avo.nome)
            })
          }

          this.nascimento.registro.data_ocorrido = moment(this.nascimento.registro.pessoa.data_nascimento).format('YYYY-MM-DD')

          this.nascimento.deleteds = this.deleteds

          const res = await NascimentoService.updateNascimento(this.nascimento.nascimento_id, this.nascimento)

          if (res) {
            displayMessage('question', 'Sucesso!', 'Deseja emitir uma ordem de serviço.').then((res) => {
              if (res.value) {
                this.nascimento.deleteds = {}

                this.$emit('goOS', this.nascimento)
              } else {
                this.$emit('changeRegistro', this.nascimento, 6)
              }
            })
          }
        } catch (error) {
          if (error.response) {
            const message = getErrors(error.response)

            return this.displayError('', message.message)
          } else {
            const message = getErrors(error)

            return this.displayError('', message.message)
          }
        }
        finally {
          loader({ text: '', active: false })
        }
      },
      getSequenciaRegistro () {
        if (!this.sequenciaRegistro  && this.nascimento.registro.registro_id ) {
          // pegando sequencia de dado do registro para identificar mudanca
          let { livro: { num_livro }, folha, termo } = this.nascimento.registro
          this.sequenciaRegistro = [num_livro, folha, termo].join('')
        }
      },
      removeGenitor (genitor_id) {
        this.deleteds.genitores.push(genitor_id)
      },
      removeGemeo (gemeo_id) {
        this.deleteds.gemeos.push(gemeo_id)
      },
      deleteAvo (avo_id) {
        this.deleteds.filiacao.push(avo_id)
      },
      scrollList () {
        const listagem = document.querySelectorAll('.is-invalid')

        if (listagem.length) {
          listagem[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }

        return listagem.length
      },
      updateOrdemNascimento (ordem) {
        this.nascimento.ordem_nascimento = ordem
      },
      changeDnv (dnv) {
        this.nascimento.numero_declaracao_nascido_vivo = dnv
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        if (this.nascimento.registro.pessoa.data_nascimento) {
          return moment(this.nascimento.registro.pessoa.data_nascimento).format("YYYY-MM-DD")
        } else {
          return moment('1500/01/01').format("YYYY-MM-DD")
        }
      },
      //Verificando campos obrigatorios
      verifyInputs () {
        this.$validator.validate().then(resp => {
          const {errors: {items}} = this.$validator
          const messages = []

          items.forEach(item => {
            switch (item.field) {
            case 'nome':
              messages.push('Informe o nome do registrado')
              break
            case 'Data Nascimento':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data de nascimento') : messages.push('Data de nascimento inválida')
              break
            case 'hora':
              messages.push('Informe a hora do nascimento')
              break
            case 'registro_livro':
              messages.push('Informe o número do livro')
              break
            case 'registro_folha':
              messages.push('Informe o número da folha')
              break
            case 'registro_termo':
              messages.push('Informe o número do registro')
              break
            case 'data_registro':
              item.msg == "Campo obrigatório" ? messages.push('Informe a data do registro') : messages.push('Data do registro inválida')
              break
            case 'digitador':
              messages.push('Informe o nome do digitador')
              break
            case 'escrevente':
              messages.push('Informe o nome do escrevente')
              break
            }     
          })
          
          if (resp && !items.length) {
            this.save()
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
            !!messages ? this.showErrorList(messages) : ''
          }
        })
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      async loadUsers () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        this.digitadores = []

        let usuarios = response.data || []

        this.digitadores = usuarios
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )

        const user = this.$store.state.auth.usuario

        if (!this.nascimento.registro.escrevente && !!user.escrevente) {
          this.nascimento.registro.escrevente = user.nome
          this.nascimento.registro.cargo_escrevente = user.cargo
        }
        if (!this.nascimento.registro.digitador) this.nascimento.registro.digitador = user.nome

        // nome oficial
        if (!this.nascimento.registro.oficial) {
          this.nascimento.registro.oficial = this.cartorioObj.nome_oficial
        }
      },
      changeEscrevente () {
        if (this.nascimento.registro.escrevente) {
          const selectEscreventes = document.getElementById('selectEscrevente')
          this.nascimento.registro.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex - 1].cargo
        }
        this.changed()
      }
    }
  }
</script>

<style lang="scss">
  .SegundaViaNascimento {
    &_header {
      background-color: #074F7F !important;
      color: white !important;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 0px;
    }


    &_body {
      &_header {
        background-color: #eaeaea !important;
        color: #000 !important;
        padding: 10px;
        font-size: 16px;
        font-weight: bold;
        border-radius: 0px;
      }
    }
  }
</style>
